import { useEffect, useState } from "react";
import { AdminLogin } from "./AdminLogin.jsx";
import { AdminDashboard } from "./AdminDashboard.jsx";
import { authedAxios, formatApiErrorDetail } from "./api.js";
import BrandLogo from "@/components/BrandLogo.jsx";

export default function AdminApp() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    authedAxios
      .get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => setUser(false));
  }, []);

  return (
    <div className="min-h-screen bg-zinc-50 font-sans text-ink" data-testid="admin-app">
      {user === null ? (
        <div className="flex min-h-screen items-center justify-center">
          <div className="flex items-center gap-3 text-zinc-400" data-testid="admin-loading">
            <BrandLogo size={28} rounded="rounded-lg" fallbackBg="bg-brand" />
            <span className="text-sm">Checking session…</span>
          </div>
        </div>
      ) : user === false ? (
        <AdminLogin onLogin={setUser} />
      ) : (
        <AdminDashboard user={user} onLogout={() => setUser(false)} />
      )}
    </div>
  );
}

export { formatApiErrorDetail };
